import NavigationBox from "components/mypage/NavigationBox";
import Profile from "components/common/Profile";

function Mypage() {
  return (
    <>
      <Profile />
      <NavigationBox />
    </>
  );
}

export default Mypage;
